// @flow

import createVersions from './create-versions';
import queries from './queries_web_apple_ios';

export default createVersions('ios', queries, false);
